'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../providers/ClaimBuilder/index.js');
var SessionContext = require('../../providers/SessionContext.js');
var useIsMobile = require('../../providers/useIsMobile.js');
var ItemPhotoDesktop = require('./ItemPhotoDesktop.js');
var ItemPhotoMobile = require('./ItemPhotoMobile.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemPhoto = _ref => {
  let {
    claimType
  } = _ref;
  const isMobile = useIsMobile["default"]();
  const {
    state: {
      currentItemClaim
    },
    handleItemClaimDetailUpdate,
    getFullItemDetails,
    handleNavigateBack
  } = index.useClaimBuilder();
  const {
    claimsPhotoUploadTitleItemDamaged,
    claimsPhotoUploadTitleWrongItem,
    claimsPhotoUploadTitleItemMissing
  } = nthHookTranslations.useTranslations();
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const currentItemDetails = currentItemClaim !== null && currentItemClaim !== void 0 && currentItemClaim.uid ? getFullItemDetails(currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.uid, currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.packageId) : null;
  const [error, setError] = React.useState(null);
  const {
    claimsPhotoUploadErrorFileType,
    claimsPhotoUploadErrorSize
  } = nthHookTranslations.useTranslations();
  const [photos, setPhotos] = React.useState((currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.photos) ?? []);
  const translationsMap = {
    WrongItem: {
      photoUploadTitle: claimsPhotoUploadTitleWrongItem ?? ''
    },
    ItemDamaged: {
      photoUploadTitle: claimsPhotoUploadTitleItemDamaged ?? ''
    },
    ItemMissing: {
      photoUploadTitle: claimsPhotoUploadTitleItemMissing ?? ''
    }
  };
  React.useEffect(() => {
    var _currentItemClaim$cur;
    // Note: This effect is only called on first component render
    const claimSteps = (currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.claimSteps.map(claimStep => claimStep.id)) ?? [];
    titan === null || titan === void 0 ? void 0 : titan.batch({
      batch: [{
        type: 'page',
        name: 'Item Photo'
      }, {
        type: 'track',
        event: 'product_viewed',
        properties: {
          product_id: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.itemId,
          sku: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.sku,
          name: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.name,
          extra_properties: [{
            key: 'claim_steps',
            value: claimSteps.join(',')
          }, {
            key: 'current_claim_step',
            value: currentItemClaim === null || currentItemClaim === void 0 ? void 0 : (_currentItemClaim$cur = currentItemClaim.currentClaimStep) === null || _currentItemClaim$cur === void 0 ? void 0 : _currentItemClaim$cur.id
          }]
        }
      }]
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.PAGE_LOAD,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_PHOTO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_PHOTO,
      order_number: orderNumber,
      claim_reason: claimType
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!currentItemDetails || !currentItemClaim) {
    // This is already handled in the Guarded component below
    // FIXME: Only make this check once in the Guarded component
    return null;
  }
  const handleChangeFile = event => {
    setError(null);
    const newPhotos = Array.from(event.target.files || []);
    const photosValidation = newPhotos.map(file => ({
      contentType: file.type,
      size: file.size
    }));
    const validationResult = index.CreateClaimPhotosSchema.safeParse(photosValidation);
    if (validationResult.success) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ITEM_PHOTO_UPLOADED,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_PHOTO,
        page_step: useAnalytics.ClaimsPageStep.SELECTION_PHOTO,
        order_number: orderNumber,
        claim_reason: claimType
      });
      setPhotos([...photos, ...newPhotos.map(file => ({
        file,
        objectUrl: URL.createObjectURL(file)
      }))]);
    } else {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ITEM_PHOTO_UPLOADED_FAILED,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_PHOTO,
        page_step: useAnalytics.ClaimsPageStep.SELECTION_PHOTO,
        order_number: orderNumber,
        claim_reason: claimType
      });
      const errorCode = validationResult.error.errors[0].code;
      if (errorCode === 'too_big') {
        setError(claimsPhotoUploadErrorSize || '');
      } else {
        setError(claimsPhotoUploadErrorFileType || '');
      }
    }
  };
  const handleRemovePhoto = index => {
    setPhotos([...photos.slice(0, index), ...photos.slice(index + 1)]);
  };
  const handleSubmit = () => {
    if (!photos.length) return;
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ITEM_PHOTO_NEXT,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_PHOTO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_PHOTO,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleItemClaimDetailUpdate({
      update: {
        photos
      },
      step: index.ClaimStepId.PHOTOS
    });
    const {
      claimSteps
    } = currentItemClaim;
    const isLastStep = claimSteps[claimSteps.length - 1].id === index.ClaimStepId.PHOTOS;
    if (isLastStep) {
      var _currentItemClaim$pho;
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'product_added',
        properties: {
          product_id: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.itemId,
          sku: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.sku,
          name: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.name,
          extra_properties: [{
            key: 'product_quantity',
            value: `${currentItemClaim.quantity}`
          }, {
            key: 'product_additional_info_comment',
            value: currentItemClaim.additionalInfo.comment
          }, {
            key: 'product_additional_info_confirmation',
            value: currentItemClaim.additionalInfo.confirmationChecked ? 'true' : 'false'
          }, {
            key: 'product_number_of_photos_added',
            value: `${((_currentItemClaim$pho = currentItemClaim.photos) === null || _currentItemClaim$pho === void 0 ? void 0 : _currentItemClaim$pho.length) ?? 0}`
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  };
  const handleBack = () => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ITEM_PHOTO_BACK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_PHOTO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_PHOTO,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleNavigateBack();
  };
  const translations = translationsMap[claimType];
  return isMobile ? /*#__PURE__*/React__default["default"].createElement(ItemPhotoMobile["default"], {
    photos: photos,
    itemDetails: currentItemDetails,
    claimDetails: currentItemClaim,
    onRemovePhoto: handleRemovePhoto,
    onChangeFile: handleChangeFile,
    onSubmit: handleSubmit,
    onBack: handleBack,
    error: error,
    computedTranslations: translations
  }) : /*#__PURE__*/React__default["default"].createElement(ItemPhotoDesktop["default"], {
    photos: photos,
    itemDetails: currentItemDetails,
    claimDetails: currentItemClaim,
    onRemovePhoto: handleRemovePhoto,
    onChangeFile: handleChangeFile,
    onSubmit: handleSubmit,
    onBack: handleBack,
    error: error,
    computedTranslations: translations
  });
};
const ItemPhotoGuarded = () => {
  const {
    state: {
      currentItemClaim,
      claimType
    },
    getFullItemDetails,
    handleInvalidData
  } = index.useClaimBuilder();
  const currentItemDetails = currentItemClaim !== null && currentItemClaim !== void 0 && currentItemClaim.uid ? getFullItemDetails(currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.uid, currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.packageId) : null;
  if (!currentItemDetails || !currentItemClaim || !index.isItemClaimType(claimType)) {
    handleInvalidData();
    return null;
  }

  // Not sure why I have to force typescript to believe claimType is an ItemClaimType
  // here when I believe it should be able to infer that from the above if statement
  return /*#__PURE__*/React__default["default"].createElement(ItemPhoto, {
    claimType: claimType
  });
};
var ItemPhoto$1 = nthHookTranslations.withTranslationsProvider(ItemPhotoGuarded, {
  translationKeys: ['claimsPhotoUploadErrorFileType', 'claimsPhotoUploadErrorSize', 'claimsPhotoUploadTitleItemDamaged', 'claimsPhotoUploadTitleItemMissing', 'claimsPhotoUploadTitleWrongItem']
});

exports["default"] = ItemPhoto$1;
